(function ($) {

    const search2 = () => {
        const form = document.getElementById('endorsement-search');
        if (form != null) {
            const inputs = form.querySelectorAll('input[type="checkbox"], select');

            inputs.forEach(input => {
                input.addEventListener('change', () => {
                    const formData = new FormData(form);
                    const urlParams = new URLSearchParams();
                    formData.forEach((value, key) => {
                        console.log(key, value);
                        urlParams.append(key, value);
                    });
                    form.action = `?${urlParams.toString()}`;
                    console.log(form.action);
                    form.submit();
                });
            });
        }
    }

    $(function () {
        search2()
    })
})(jQuery);
